import { createApi } from '@reduxjs/toolkit/query/react';
import { Response } from '../../models/shared';
import {
  CommunicationsDTO, ReminderPreviewDTO, ReminderPreviewVariant, SendManualReminderResultDTO, UpdateReminderConfigDTO,
} from '../../models/communication';
import baseQueryWithReauth from './base';

const communicationsApi = createApi({
  reducerPath: 'communicationsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['communications'],
  endpoints: (build) => ({
    getCommunications: build.query<(CommunicationsDTO | null), { businessId: string, eventId: string }>({
      providesTags: ['communications'],
      query: ({ businessId, eventId }) => ({
        url: `/businesses/${businessId}/events/${eventId}/reminders`,
        method: 'GET',
      }),
      transformResponse: (response: Response<CommunicationsDTO>): (CommunicationsDTO | null) => response.data || null,
    }),
    updateReminderConfig: build.mutation<Response<CommunicationsDTO>, { businessId: string, eventId: string, config: UpdateReminderConfigDTO }>({
      query: ({ businessId, eventId, config }) => ({
        url: `/businesses/${businessId}/events/${eventId}/reminders`,
        method: 'PUT',
        body: config,
      }),
      invalidatesTags: ['communications'],
    }),
    sendManualReminder: build.mutation<Response<SendManualReminderResultDTO>, { businessId: string, eventId: string }>({
      query: ({ businessId, eventId }) => ({
        url: `/businesses/${businessId}/events/${eventId}/reminders/send`,
        method: 'POST',
      }),
      invalidatesTags: ['communications'],
    }),
    getReminderPreview: build.query<(ReminderPreviewDTO | null), { businessId: string, eventId: string, variant: ReminderPreviewVariant }>({
      query: ({ businessId, eventId, variant }) => ({
        url: `/businesses/${businessId}/events/${eventId}/reminders/preview?variant=${variant}`,
        method: 'GET',
      }),
      transformResponse: (response: Response<ReminderPreviewDTO>): (ReminderPreviewDTO | null) => response.data || null,
    }),
  }),
});

export const {
  useGetCommunicationsQuery, useUpdateReminderConfigMutation, useSendManualReminderMutation, useGetReminderPreviewQuery,
} = communicationsApi;
export { communicationsApi };
